import { RefObject } from 'react';
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { CustomTable, CustomTableRef } from 'medere-ui-framework';
import { FinancerProfessionalSummaryDTO } from '../../dto/FinancerDistributionDTO';
import { PAGE_SIZE, formatMoney } from './financerDistributionFormat';

interface FinancerSummaryTableProps {
    tableRef: RefObject<CustomTableRef>;
    getItems: (offset: number, pageSize: number) => Promise<FinancerProfessionalSummaryDTO[]>;
    selection: FinancerProfessionalSummaryDTO[];
    onSelectionChange: (selection: FinancerProfessionalSummaryDTO[]) => void;
    onViewDetail: (row: FinancerProfessionalSummaryDTO) => void;
}

/** Pendiente FINANCER por profesional, paginado en el backend con el scroll. La selección se conserva al cargar más. */
export default function FinancerSummaryTable({
    tableRef, getItems, selection, onSelectionChange, onViewDetail,
}: FinancerSummaryTableProps) {
    return (
        <CustomTable
            idTable="tableFinancerPendingSummary"
            ref={tableRef}
            getItems={getItems}
            pageSize={PAGE_SIZE}
            selectionMode="checkbox"
            selectedItems={selection}
            onSelectionChange={(e) => onSelectionChange(e.value as FinancerProfessionalSummaryDTO[])}
            className="crudTable"
            filterRow={false}
            hideFiltersButton
            stateless
            notFlex
            maxHeight={560}
            notFoundText="No hay resultados para estos filtros."
        >
            <Column field="professionalName" header="Profesional" />
            <Column field="orderCount" header="Órdenes" className="text-right" headerClassName="col-right" style={{ width: '100px' }} />
            <Column header="Créditos" body={(r: FinancerProfessionalSummaryDTO) => formatMoney(r.creditAmount)}
                className="text-right" headerClassName="col-right" style={{ width: '150px' }} />
            <Column header="Débitos" body={(r: FinancerProfessionalSummaryDTO) => formatMoney(r.debitAmount)}
                className="text-right" headerClassName="col-right" style={{ width: '150px' }} />
            <Column header="Total" body={(r: FinancerProfessionalSummaryDTO) => <strong>{formatMoney(r.totalProfessionalAmount)}</strong>}
                className="text-right" headerClassName="col-right" style={{ width: '150px' }} />
            <Column
                header=""
                body={(r: FinancerProfessionalSummaryDTO) => (
                    <Button
                        text
                        rounded
                        icon="pi pi-eye"
                        className="md-icon-btn"
                        aria-label={`Ver detalle de ${r.professionalName}`}
                        tooltip="Ver detalle"
                        tooltipOptions={{ position: 'left' }}
                        onClick={() => onViewDetail(r)}
                    />
                )}
                className="text-center"
                style={{ width: '64px' }}
            />
        </CustomTable>
    );
}
